// Mini sparkline inline SVG. Sem deps. Pattern Splunk/Elastic.
// data = array de N inteiros (default 7). Renderiza linha + ponto final.

interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  className?: string;
  title?: string;
}

export function Sparkline({
  data,
  width = 60,
  height = 16,
  className = '',
  title,
}: SparklineProps) {
  if (!data || data.length === 0) {
    return <span className={`inline-block text-gray-600 ${className}`} style={{ width, height }}>—</span>;
  }

  const max = Math.max(1, ...data);
  const stepX = data.length > 1 ? width / (data.length - 1) : width / 2;
  const points = data
    .map((v, i) => {
      const x = i * stepX;
      const y = height - (v / max) * (height - 2) - 1;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  const lastVal = data[data.length - 1];
  const lastX = (data.length - 1) * stepX;
  const lastY = height - (lastVal / max) * (height - 2) - 1;
  const total = data.reduce((acc, v) => acc + v, 0);
  const tooltip = title ?? `7d trend (total ${total})`;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={`inline-block ${className}`}
      role="img"
      aria-label={tooltip}
    >
      <title>{tooltip}</title>
      <polyline
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        points={points}
      />
      <circle
        cx={lastX}
        cy={lastY}
        r="1.6"
        fill="currentColor"
      />
    </svg>
  );
}
